import { render, staticRenderFns } from "./others-column.md?vue&type=template&id=53bc2e06&"
import script from "./others-column.md?vue&type=script&lang=js&"
export * from "./others-column.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bc2e06')) {
      api.createRecord('53bc2e06', component.options)
    } else {
      api.reload('53bc2e06', component.options)
    }
    module.hot.accept("./others-column.md?vue&type=template&id=53bc2e06&", function () {
      api.rerender('53bc2e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Column/others-column.md"
export default component.exports